<template>
    <div class="screenHeader">
        <div class="headerIn">
          <!--    时钟      -->
          <div class="headerTime">
            <div class="timeImg">
              <img src="@assets/header/Vector27.png" alt="">
            </div>
            <div class="headerTimeNumber">{{ realTime }}</div>
            <div class="colon"><img src="@assets/header/Frame32.png" alt=""></div>
            <div class="headerTimeDate">{{ date }}</div>
            <div class="colon"><img src="@assets/header/Frame32.png" alt=""></div>
            <div class="headerTimeWeek">{{ week }}</div>
            <div class="timeImg">
              <img src="@assets/header/Vector28.png" alt="">
            </div>
          </div>
          <!--   标题       -->
          <div class="headerTitle">
            <span class="title" v-if="title">{{ title }}</span>
            <span class="title" v-else-if="activeScreen != 'ask'">互联网基础设施安全风险监测预警平台</span>
            <span class="title" v-else>互联网基础设施安全威胁知识搜索引擎</span>
             <div class="transition" v-if="!title">
               <span>Internet infrastructure security risk monitoring and early warning platform</span>
             </div>
              <div class="headerImg">
                <img src="@assets/header/titleBorder.svg" alt="">
              </div>
            </div>
          <!--   右侧操作区       -->
          <div class="headerSearch">
            <slot name="right-action"></slot>
          </div>

        </div>

    </div>
</template>

<script>
export default {
  name: "dp-header",
  props: {
    activeScreen: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      realTime: "",
      date: "",
      week: "",
      timerID: null,
      weekList: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ]
    };
  },
  created() {
    this.timerID = setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime() {
      let cd = new Date();

      this.realTime
            = this.zeroPadding(cd.getHours(), 2)
            + ":"
            + this.zeroPadding(cd.getMinutes(), 2)
            + ":"
            + this.zeroPadding(cd.getSeconds(), 2);
      this.date
            = this.zeroPadding(cd.getFullYear(), 4)
            + "."
            + this.zeroPadding(cd.getMonth() + 1, 2)
            + "."
            + this.zeroPadding(cd.getDate(), 2);
      this.week = this.weekList[cd.getDay()];
    },
    zeroPadding(num, digit) {
      let zero = "";

      for (let i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    }
  }
};
</script>

<style scoped lang="less">
.screenHeader{
    position: relative;
    z-index: 10;
    width: 100%;

  .headerIn{
    font-family: 'YouSheBiaoTiHei';
    display: flex;
    justify-content: space-between;
    padding: 0 clamp(20px, 3vw, 57px);
    box-sizing: border-box;
    max-width: 1920px;
    margin: 0 auto;
  }

  .headerTime {
    width: clamp(280px, 18vw, 353px);
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-top: clamp(30px, 3vw, 54px);
    padding: 0 16px;
    img{
      height: clamp(20px, 1.5vw, 28px);
    }

    .colon{
      height: clamp(20px, 1.5vw, 28px);
      line-height: clamp(20px, 1.5vw, 28px);
      img{
        width: 2px;
        height: clamp(12px, 1vw, 16px);
      }
    }
    .headerTimeNumber {
      font-family: 'D-DIN';
      width: auto;
      min-width: 60px;
      height: clamp(20px, 1.5vw, 28px);
      line-height: clamp(20px, 1.5vw, 28px);
      font-size: clamp(14px, 1.2vw, 20px);
      color: rgba(255, 255, 255, 1);
    }

    .headerTimeDate {
      font-family: 'D-DIN';
      font-size: clamp(14px, 1.2vw, 20px);
      height: clamp(20px, 1.5vw, 28px);
      line-height: clamp(20px, 1.5vw, 28px);
      color: rgba(255, 255, 255, 1);

    }

    .headerTimeWeek {
      font-size: clamp(14px, 1.2vw, 20px);
      display: inline-block;
      width: clamp(50px, 3.5vw, 60px);
      text-align: justify;
      text-justify: distribute-all-lines;
      text-align-last: justify;
      color: rgba(255, 255, 255, 1);
    }
  }

  .headerTitle{
    width: clamp(600px, 51vw, 978px);
    background: url("../assets/header/Ellipse2.svg") no-repeat;
    background-size: 100%;
    background-position: center;
    padding-top: clamp(15px, 1.5vw, 23px);
    position: relative;
    display: flex;
    flex-direction: column;
    align-content: center;
    place-items: center;
    .title{
      color: rgba(244, 248, 255, 1);
      font-size: clamp(20px, 2vw, 34px);
      line-height: clamp(30px, 2.5vw, 48px);
      letter-spacing: 0.14em;
      text-shadow: 0 2px 20px rgba(57, 93, 221, 1) ;
      z-index: 99;
    }
    .transition{
      margin: 10px 0;
      width: clamp(400px, 32vw, 613px);
      font-size: clamp(10px, 0.8vw, 12px);
      color: rgba(244, 248, 255, 1);
      text-shadow: 0 2px 20px rgba(57, 93, 221, 1) ;
    }
    .headerImg {
      margin-top: -28px;
      img {
        max-width: 100%;
      }
    }
  }

  .headerSearch{
    width: clamp(250px, 18vw, 345px);
    margin-top: clamp(35px, 3vw, 59px);
    position: relative;
    .bug{
      position: absolute;
      color: #fff;
      left: 15px;
      top: 8px;
      font-size: clamp(14px, 1.2vw, 20px);
      margin: 0 4px;
    }
    img{
      width: 100%;
    }

    .searchLogo{
      width: 15px;
      position: absolute;
      right: 30px;
      top: 11px;
    }
  }

  // 移动端适配
  @media (max-width: 768px) {
    .headerIn {
      flex-direction: column;
      align-items: center;
      padding: 10px 20px;
    }

    .headerTime {
      order: 2;
      margin-top: 10px;
      width: 100%;
      max-width: 350px;
    }

    .headerTitle {
      order: 1;
      width: 100%;
      max-width: 500px;
    }

    .headerSearch {
      order: 3;
      margin-top: 10px;
      width: 100%;
      max-width: 300px;
    }
  }
}

</style>
